const styles = () => {
  return {
    dialogPaper: {
      height: '80vh',
      minWidth: '50vw',
      maxWidth: '80vw'
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto'
    },
    title: {},
    expandAllRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      marginBottom: 10
    },
    expandAllLabel: {
      marginRight: 8
    },
    section: {
      '&:not(:last-child)': {
        marginBottom: 20
      }
    },
    sectionTitle: {
      fontWeight: 700,
      fontSize: '1.1rem',
      marginBottom: 10
    },
    table: {
      width: '100%'
    },
    labelCell: {
      fontWeight: 600,
      whiteSpace: 'nowrap',
      verticalAlign: 'top',
      width: 250,
      minWidth: 250,
      maxWidth: 250
    },
    valueCell: {
      wordBreak: 'break-word'
    },
    arrayItem: {
      '&:not(:last-child)': {
        marginBottom: 10
      }
    },
    arrayItemLabel: {
      fontWeight: 600,
      opacity: 0.7
    }
  };
};

export default styles;
